import { css } from "@emotion/react";
import { useTailwindMediaQueries } from "@/hooks/useTailwindMediaQueries";
import type { ImmutableObject } from "@/lib/immutable";
import type { PackageItem, Product } from "../../../hooks/useInventoryState";
import { useShoppingCartItemsState } from "../../../hooks/useShoppingCartItemsState";
import FwFunc from "../../../lib/FwReact/FwFunc";
import { ShoppingCartPackageItemAvailability } from "../PackageItemFields/ShoppingCartPackageItemAvailability";
import type { ShoppingCartViewSettings } from "../ShoppingCartControl";

//------------------------------------------------------------------------------------
export type ShoppingCartPackageItemIncludedDesktopProps = {
	packageProduct: ImmutableObject<Product>;
	packageItem: ImmutableObject<PackageItem>;
	enableQty: boolean;
	viewSettings: ShoppingCartViewSettings;
};
export const ShoppingCartPackageItemIncludedDesktop: React.FC<
	ShoppingCartPackageItemIncludedDesktopProps
> = (props) => {
	const mediaQueries = useTailwindMediaQueries();
	const packageProduct = props.packageProduct;
	const isAvailable = (packageProduct.Availability?.TotalIn ?? 0) > 0;
	const canAddToCart =
		props.enableQty &&
		(isAvailable || props.viewSettings.allowAddingUnavailableItems);
	const item = props.packageItem;
	//const qtyState = useFwNumberBoxState();
	const shoppingCartItemsState = useShoppingCartItemsState();
	// const showImage = item.Images && (item.Images.length > 0);
	const showAvailability = item.Availability !== undefined;
	const showDailyRate =
		mediaQueries.tablet &&
		props.viewSettings.hasRates &&
		props.viewSettings.hasDailyRate;
	const showWeeklyRate =
		mediaQueries.tablet &&
		props.viewSettings.hasRates &&
		props.viewSettings.hasWeeklyRate;
	const showMonthlyRate =
		mediaQueries.tablet &&
		props.viewSettings.hasRates &&
		props.viewSettings.hasMonthlyRate;

	const dailyRate = item.DailyExtended;
	const weeklyRate = item.WeeklyExtended;
	const monthlyRate = item.MonthlyExtended;

	//const handleChangeQtyAsync = async (value: number): Promise<void> => {
	//    return Promise.resolve().then(() => {
	//        shoppingCartItemsState.setPackageItemQty(props.packageProduct, props.packageItem, value);
	//    });
	//}

	return (
		<tr
			className="packageitemrow"
			style={
				{
					/*backgroundColor: item.LineColor*/
				}
			}
		>
			<td className="col-legend"></td>
			{/*<td className="col-image">*/}
			{/*    {showImage && (*/}
			{/*        <ShoppingCartPackageItemImage product={packageProduct} packageItem={item} />*/}
			{/*    )}*/}
			{/*</td>*/}
			{/*<div className="fld ICode">{item.ICode}</div>*/}
			<td className="col-description">{item.Description}</td>
			{/*<td className="Tags">*/}
			{/*    {item.IsOption && (*/}
			{/*        <Chip label={'optional'} style={{backgroundColor: 'yellow', color: 'black'}}></Chip>*/}
			{/*    )}*/}
			{/*    <Chip label={`x${item.DefaultQuantity}`} style={{ backgroundColor: 'orange', color: 'black' }}></Chip>*/}
			{/*</td>*/}
			{(canAddToCart || showAvailability) && (
				<td className="col-qty">
					{canAddToCart && (
						<div>
							{shoppingCartItemsState.getPackageItemQty(
								props.packageProduct,
								item,
							)}
						</div>
					)}
				</td>
			)}
			{showDailyRate && (
				<td className="col-dailyrate">
					<span className="CurrencySymbol">{item.CurrencySymbol}</span>
					<span className="Price">
						{FwFunc.numberFormatter(dailyRate, 2, ",", ".")}
					</span>
					{/*<span className="Price">{FwFunc.numberFormatter(item.DailyRate, 2, ',', '.')}</span>*/}
					{/*<span className="CurrencyCode">{item.CurrencyCode}</span>*/}
				</td>
			)}

			{showWeeklyRate && (
				<td className="col-weeklyrate">
					<span className="CurrencySymbol">{item.CurrencySymbol}</span>
					<span className="Price">
						{FwFunc.numberFormatter(weeklyRate, 2, ",", ".")}
					</span>
					{/*<span className="CurrencyCode">{item.CurrencyCode}</span>*/}
				</td>
			)}

			{showMonthlyRate && (
				<td className="col-monthlyrate">
					<span className="CurrencySymbol">{item.CurrencySymbol}</span>
					<span className="Price">
						{FwFunc.numberFormatter(monthlyRate, 2, ",", ".")}
					</span>
					{/*<span className="CurrencyCode">{item.CurrencyCode}</span>*/}
				</td>
			)}
			{false && showAvailability && (
				<td
					className="col-availability"
					css={css`/*display:flex;align-items:center;width:100px;*/`}
				>
					<ShoppingCartPackageItemAvailability packageItem={item} />
				</td>
			)}
		</tr>
	);
};
